export enum ProbationStatus {
  Confirmed = "Confirmed",
  Probations = "Probations",
}
